import api from '../utils/functions/api';

const baseURL = process.env.REACT_APP_API_URL;

async function getMerchantNameApi(merchantPath) {
    try {
        const resp = await api.get(`${baseURL}/manage-users/get-merchant-name/${merchantPath}`);

        return resp.data
    } catch (error) {
        console.log("error : ", error);
        throw new Error(error);
    }
}

async function getNameByOneIdApi() {
    try {
        const resp = await api.get(`${baseURL}/manage-users/get-user-name`);

        return resp.data
    } catch (error) {
        console.log("error : ", error);
        throw new Error(error);
    }
}

const UserListApi = {
    getMerchantNameApi,
    getNameByOneIdApi
};

export default UserListApi;